import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { Spin } from "antd";
import SliderSlice from "./SliderSlice";
import SmsDonationPopup from "components/smsDonation/SmsDonationPopup";
import DonateNow from "components/DonateNow";
import { campaignListAction } from "redux/actions/CampaignList/campaignListAction";

const Hero = () => {
  const dispatch: any = useDispatch();

  useEffect(() => {
    dispatch(campaignListAction());
  }, [dispatch]);

  const { campaignListLoading, campaignList } = useSelector(
    (state: RootState) => state.campaignListReducer
  );

  // donate now logic
  const [showDonateNow, setShowDonateNow] = useState<boolean[]>(
    new Array(campaignList?.length).fill(false)
  );

  const handleDonateNowToggle = (index: number) => {
    setShowDonateNow((prev) => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  };

  // sms donation logic
  const [showSmsDonation, setShowSmsDonation] = useState<boolean[]>(
    new Array(campaignList?.length).fill(false)
  );

  const handleSmsDonationToggle = (index: number) => {
    setShowSmsDonation((prev) => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  };

  return (
    <>
      {/* projects slider  *****************************/}
      <Spin spinning={campaignListLoading}>
        <Splide
          className="mt-[-12px]"
          options={{
            direction: `${
              localStorage.getItem("dir") === "rtl" ? "rtl" : "ltr"
            }`,
            grag: "free",
            arrows: false,
            pagination: false,
            width: "100%",
            autoplay: true,
            rewind: true,
            perMove: 1,
            easing: "ease-out",
            speed: 1000,
            interval: 5000,
            pauseOnHover: false,
            pauseOnFocus: true,
            breakpoints: {
              1920: { perPage: 1, gap: 0 },
            },
          }}
        >
          {campaignList?.map((project: any, i: number) => {
            return (
              <SplideSlide key={i} className="relative">
                <SliderSlice
                  project={project}
                  showSmsDonation={showSmsDonation[i]}
                  setShowSmsDonation={() => handleSmsDonationToggle(i)}
                  showDonateNow={showDonateNow[i]}
                  setShowDonateNow={() => handleDonateNowToggle(i)}
                />
              </SplideSlide>
            );
          })}
        </Splide>
      </Spin>

      {campaignList?.map((project: any, i: number) => {
        return (
          <div key={i}>
            {showSmsDonation[i] && (
              <SmsDonationPopup
                project={campaignList?.at(i)}
                show={showSmsDonation?.at(i) ?? false}
                setShow={() => handleSmsDonationToggle(i)}
              />
            )}
          </div>
        );
      })}

      {campaignList?.map((project: any, i: number) => {
        return (
          <div key={i}>
            {showDonateNow[i] && (
              <DonateNow
                project={campaignList?.at(i)}
                show={showDonateNow?.at(i) ?? false}
                setShow={() => handleDonateNowToggle(i)}
              />
            )}
          </div>
        );
      })}
    </>
  );
};

export default Hero;
